
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { shelfNumberRulesEl } from "@common/src/utils/verify";
import AreaSelect from "@/components/scope/area-select.vue";
import t from "@common/src/i18n/t";
const base = namespace("base");
const warehouse = namespace("warehouse");

@Component({
  components: { AreaSelect }
})
export default class SupplierEdit extends Vue {
  @warehouse.Action createWarehouseShelf;
  @warehouse.Action queryWarehouseShelfDetail;
  @warehouse.Action updateWarehouseShelf;
  @warehouse.Action saveWarehouseShelfClass;
  @warehouse.Action queryWarehouseShelfClass;
  @base.Action getDictionaryList;
  @warehouse.Action getWarehouseList;
  get breadData() {
    return [
      { name: t("v210.location-information"), path: "/inventory/shelf/list" },
      {
        name: this.isAdd ? t("v210.add-location") : t("v210.edit-location")
      }
    ];
  }
  showAreaSelect: boolean = false;
  shelfFormData = {
    shelfName: "",
    shelfNumber: "",
    shelfClass: "",
    warehouseCode: "",
    whetherDefault: 0,
    enabledStatus: 1
  };
  roleList: any[] = [];
  areaOptions: any[] = [];
  areaValue: any = "";
  get shelfFormRules() {
    return {
      shelfName: [{ required: true, message: t("v210.please-enter-the-location-name"), trigger: "blur" }],
      shelfNumber: [{ validator: this.checkShelfNumber, trigger: "blur" }],
      shelfClass: [{ required: true, message: t("v210.please-select-location-classification"), trigger: "change" }],
      warehouseCode: { required: true, message: t("v210.please-select-the-warehouse"), trigger: "change" },
      whetherDefault: { required: true },
      enabledStatus: { required: true }
    };
  }
  get isAdd() {
    return this.$route.name === "ShelfAdd";
  }
  created() {
    this.init();
  }
  checkShelfNumber(rule, value, callback) {
    shelfNumberRulesEl(value, callback, true);
  }
  submitForm(formName) {
    (this.$refs[formName] as any).validate(valid => {
      if (valid) {
        if (this.isAdd) {
          this.addShelf();
        } else {
          this.editShelf();
        }
      } else {
        console.log("error submit!!");
        return false;
      }
    });
  }
  warehouseList: any = [];
  warehouseClassList: any = [];
  warehouseClassListAll: any = [];
  async init() {
    if (!this.isAdd) {
      const data = await this.queryWarehouseShelfDetail({
        shelfCode: this.$route.params.id
      });
      this.shelfFormData = data.data;
    }
    this.getWarehouseList({
      pageSize: 999
    }).then(data => {
      this.warehouseList = this.$safeValue(data, "data.list", []).map(item => {
        item.label = item.warehouseName;
        item.value = item.warehouseCode;
        return item;
      });
    });
    this.getShelfClassList();
  }
  getShelfClassList(callback?) {
    return this.queryWarehouseShelfClass().then(data => {
      this.warehouseClassList = this.$safeValue(data, "data.list");
      this.warehouseClassListAll = this.$safeValue(data, "data.list");
      callback && callback();
    });
  }
  async addShelf() {
    this.createWarehouseShelf(this.shelfFormData).then(() => {
      this.$message.success(t("base.success") as any);
      this.$router.push(`/inventory/shelf/list`);
    });
  }

  async editShelf() {
    this.updateWarehouseShelf(
      Object.assign({}, this.shelfFormData, {
        shelfCode: this.$route.params.id
      })
    ).then(() => {
      this.$message.success(t("base.success") as any);
      this.$router.push(`/inventory/shelf/list`);
    });
  }
  shelfClassSearchValue = "";
  handleSearchShelfClass(val) {
    if (val) {
      this.shelfClassSearchValue = val;
      this.warehouseClassList = this.warehouseClassListAll.filter(item => {
        return item.shelfClass.includes(val);
      });
    } else {
      this.warehouseClassList = this.warehouseClassListAll.slice();
    }
  }
  async handleAddShelfClass() {
    (this.$refs["shelfClassSelect"] as any).blur();
    await this.saveWarehouseShelfClass({ shelfClass: this.shelfClassSearchValue });
    this.getShelfClassList(() => {
      this.$nextTick(() => {
        this.shelfFormData.shelfClass = this.shelfClassSearchValue;
      });
    });
  }
}
